import cls from "classnames";
import React, { Component } from "react";
import FlipMove from "react-flip-move";
import Measure from "react-measure";
import { RicosContext } from "./../../ricos-context/index.js";
import {
  PollData_Layout_PollLayout_Type,
  PollData_Poll_Settings_Permissions_ViewRole
} from "./../../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { AddIcon } from "../assets/icons/add-icon.js";
import { LoaderIcon } from "../assets/icons/loader-icon.js";
import { withPoll } from "../components/poll-context/poll-context.js";
import { PollContextPropTypes } from "../components/poll-context/types.js";
import { PollHeader } from "../components/poll-header/poll-header.js";
import { PollOption } from "../components/poll-option/index.js";
import styles from "../components/poll-scss.js";
import { RCEHelpersPropTypes, withRCEHelpers } from "../components/rce-helpers-context/index.js";
import { VotedUsers } from "../components/voted-users/voted-users.js";
import {
  POLLS_ADD_ANSWER_BUTTON,
  POLLS_ANSWER_ITEMS,
  POLLS_MULTIPLE_ANSWER_TEXT,
  ROOT
} from "../data-hooks.js";
import { toBackgroundString } from "../helpers.js";
class PollComponent extends Component {
  constructor(props) {
    super(props);
    this.vote = async (optionId) => {
      this.setState({ error: null });
      try {
        await this.props.vote(optionId);
      } catch (error) {
        console.error("[rce-social-polls] vote: ", error.response);
        this.setState({ error: error.message });
        return Promise.reject(error);
      }
    };
    this.unvote = async (optionId) => {
      this.setState({ error: null });
      try {
        await this.props.unvote(optionId);
      } catch (error) {
        console.error("[rce-social-polls] unvote: ", error.response);
        this.setState({ error: error.message });
        return Promise.reject(error);
      }
    };
    this.toggleCollapse = () => this.setState({ collapsed: !this.state.collapsed });
    this.handleCTAFocus = (e) => {
      e.stopPropagation();
      this.props.rce.setInPluginEditingMode(true);
    };
    this.handleCTABlur = () => this.props.rce.setInPluginEditingMode(false);
    this.onResize = ({ bounds }) => this.setState({ bounds });
    this.state = {
      collapsed: this.isInitiallyCollapsed(),
      error: null,
      loading: false,
      bounds: null
    };
  }
  async componentDidMount() {
    const { poll } = this.props;
    if (poll.id) {
      this.fetchPoll();
    }
  }
  componentDidCatch(error) {
    console.error(error);
    this.setState({ error: error.message });
  }
  async fetchPoll() {
    const { t } = this.context;
    if (this.props.rce.isWebView || this.props.rce.preventInteraction) {
      return;
    }
    this.setState({
      loading: true,
      error: null
    });
    try {
      await this.props.fetchPoll();
    } catch (error) {
      console.error("[rce-social-polls] fetchPoll: ", error);
      this.setState({ error: t("Poll_Viewer_Toast_Error_ServerDown") });
    } finally {
      this.setState({ loading: false });
    }
  }
  isInitiallyCollapsed() {
    const { poll } = this.props;
    return poll.options.length > 4;
  }
  handleOptionUpdate(index) {
    return (option) => this.props.updatePollOption(index, option);
  }
  handleOptionRemove(index) {
    return () => this.props.removeOption(index);
  }
  getNotes() {
    const { poll } = this.props;
    const { t } = this.context;
    return [
      {
        condition: poll.settings.permissions?.allowMultipleVotes,
        label: t("Poll_Viewer_Multiselect_Footer")
      },
      {
        condition: poll.settings.permissions?.view === PollData_Poll_Settings_Permissions_ViewRole.CREATOR && poll.creatorFlag,
        label: t("Poll_Viewer_Visibility_Owner_Footer")
      }
    ].filter((note) => !!note.condition);
  }
  showResults() {
    const { permissions } = this.props.poll.settings;
    switch (permissions?.view) {
      case PollData_Poll_Settings_Permissions_ViewRole.EVERYONE:
        return true;
      case PollData_Poll_Settings_Permissions_ViewRole.VOTERS:
        return this.props.poll.creatorFlag || !!this.props.poll.ownVotes?.length;
      case PollData_Poll_Settings_Permissions_ViewRole.CREATOR:
        return this.props.poll.creatorFlag;
      default:
        return false;
    }
  }
  hasImageBackground() {
    return !!this.props.design.poll?.background?.image?.src?.url;
  }
  getOptionList() {
    const { poll, rce } = this.props;
    const { collapsed } = this.state;
    if (!rce.isViewMode || this.showEditControls()) {
      return poll.options;
    }
    let list;
    if (!this.showResults()) {
      list = poll.options;
    } else {
      list = Array.from(poll.options).sort((prev, option) => {
        if (!prev.rating) {
          return 1;
        }
        if (option.rating === prev.rating) {
          return 0;
        }
        if (option.rating > prev.rating) {
          return 1;
        }
        return -1;
      });
    }
    return collapsed ? list.slice(0, 4) : list;
  }
  showEditControls() {
    const { rce } = this.props;
    return !rce.isViewMode && !rce.isPreview;
  }
  render() {
    const { poll, rce, getVoters, addOption, design, layout, siteMembers } = this.props;
    const { collapsed, loading, bounds } = this.state;
    const { isMobile, t } = this.context;
    const style = {
      ...design.poll,
      background: toBackgroundString(
        design.poll?.background,
        design.poll?.background.type,
        bounds?.width,
        bounds?.height
      )
    };
    return /* @__PURE__ */ React.createElement(Measure, { bounds: true, onResize: this.onResize }, ({ measureRef }) => /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cls(styles.container, {
          [styles.isMobile]: isMobile,
          [styles.webview]: rce.isWebView,
          [styles.fullscreen]: rce.isPreview,
          [styles.dark]: this.hasImageBackground()
        }),
        style,
        dir: layout.poll?.direction,
        ref: measureRef,
        "data-hook": ROOT
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cls(styles.background_overlay, {
            [styles.with_image]: this.hasImageBackground()
          })
        }
      ),
      /* @__PURE__ */ React.createElement(PollHeader, null),
      /* @__PURE__ */ React.createElement(
        "ul",
        {
          className: cls(styles.options, {
            [styles.list]: layout.poll?.type === PollData_Layout_PollLayout_Type.LIST,
            [styles.grid]: layout.poll?.type === PollData_Layout_PollLayout_Type.GRID,
            [styles.with_image]: layout.options?.enableImage
          })
        },
        /* @__PURE__ */ React.createElement(
          FlipMove,
          {
            typeName: null,
            disableAllAnimations: this.showEditControls(),
            enterAnimation: "none",
            leaveAnimation: "none",
            verticalAlignment: "bottom"
          },
          this.getOptionList().map((option, i) => /* @__PURE__ */ React.createElement("li", { className: styles.option, key: option.id || i, "data-hook": POLLS_ANSWER_ITEMS }, /* @__PURE__ */ React.createElement(
            PollOption,
            {
              option,
              update: this.handleOptionUpdate(i),
              remove: this.handleOptionRemove(i),
              removeEnabled: this.showEditControls() && poll.options.length > 1,
              vote: this.vote,
              unvote: this.unvote,
              poll,
              showResults: this.showResults(),
              dark: this.hasImageBackground()
            }
          ), /* @__PURE__ */ React.createElement(
            VotedUsers,
            {
              option,
              siteMembers,
              showResults: this.showResults(),
              showVoters: poll.settings.showVoters,
              showVotes: poll.settings.showVotesCount,
              fetchVoters: (params) => getVoters(option.id, params)
            }
          ))),
          this.showEditControls() && /* @__PURE__ */ React.createElement("li", { className: styles.column }, /* @__PURE__ */ React.createElement(
            "button",
            {
              onClick: addOption,
              onFocus: this.handleCTAFocus,
              onBlur: this.handleCTABlur,
              className: styles.add_option,
              style: design.options,
              type: "button",
              "data-hook": POLLS_ADD_ANSWER_BUTTON
            },
            layout.poll?.type === PollData_Layout_PollLayout_Type.GRID && layout.options?.enableImage ? /* @__PURE__ */ React.createElement(AddIcon, null) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(AddIcon, { width: 24, height: 24 }), " ", t("Poll_Editor_Answer_AddAnswer"))
          ))
        )
      ),
      poll.options.length > 4 && !this.showEditControls() && /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.toggleCollapse,
          className: styles.see_more,
          style: design.options,
          type: "button"
        },
        collapsed ? this.showResults() ? t("Poll_Viewer_ShowAllResults_CTA") : t("Poll_Viewer_ShowAllOptions_CTA") : t("Poll_Viewer_ShowLess_CTA")
      ),
      this.getNotes().map((note, i) => /* @__PURE__ */ React.createElement("p", { className: styles.additional_note, key: i, "data-hook": POLLS_MULTIPLE_ANSWER_TEXT }, note.label)),
      /* @__PURE__ */ React.createElement(
        LoaderIcon,
        {
          className: cls(styles.spinner, {
            [styles.shown]: loading
          }),
          width: 24,
          height: 24
        }
      )
    ));
  }
}
PollComponent.propTypes = {
  ...PollContextPropTypes,
  ...RCEHelpersPropTypes
};
PollComponent.contextType = RicosContext;
const Poll = withRCEHelpers(withPoll(PollComponent));
export {
  Poll
};
//# sourceMappingURL=poll-component.js.map
